/**
 * Returns the highest role for a user, excluding superadmin.
 */
export function getHighestRole(roles: string[] = []) {
  if (roles.includes('superadmin')) {
    return 'superadmin'
  } else if (roles.includes('support')) {
    return 'support'
  } else if (roles.includes('paintscout_sales')) {
    return 'paintscout_sales'
  } else if (roles.includes('corporate')) {
    return 'corporate'
  } else if (roles.includes('core')) {
    return 'core'
  } else if (roles.includes('team')) {
    return 'team'
  } else if (roles.includes('painter')) {
    return 'painter'
  } else if (roles.includes('admin')) {
    return 'admin'
  } else if (roles.includes('sales')) {
    return 'sales'
  } else if (roles.includes('crew')) {
    return 'crew'
  } else if (roles.includes('viewer')) {
    return 'viewer'
  }
}
